// extracted by mini-css-extract-plugin
module.exports = {"sample__imgContainer":"page_sample__imgContainer__Lmfro","sample__content":"page_sample__content__pXsD2","sample__subtitle":"page_sample__subtitle__DNCRE"};